import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

// import ArrowRightAlt from '@material-ui/icons/ArrowRightAlt';
// import LocalPhone from '@material-ui/icons/LocalPhone';
import MobilePhone from '@material-ui/icons/Smartphone';

import HeaderBar from '../components/HeaderBar';
import positive from '../components/positive.png';
import uncertain from '../components/uncertain.png';
import negative from '../components/negative.png';
import CONSTANTS from '../utils/Constants';

const styles = theme => ({
	phone: {
		marginLeft: 2 * theme.spacing.unit
	},
	imgBtn: {
		width: 9 * theme.spacing.unit,
		height: 9 * theme.spacing.unit,
	},
	btnLabel: {
		textAlign: "center"
	},
	gridContainer: {
		padding: theme.spacing.unit,
		marginTop: -4 * theme.spacing.unit,
		[theme.breakpoints.up('sm')]: {
			paddingTop: theme.spacing.unit,
			marginTop: 0
		},
		[theme.breakpoints.up('lg')]: {
			marginTop: -2.5 * theme.spacing.unit
		},
	},

	screenLabel: {
		[theme.breakpoints.up('lg')]: {
			marginBottom: theme.spacing.unit,
		},
		[theme.breakpoints.up('sm')]: {
			marginBottom: 3 * theme.spacing.unit
		},
	},

	contactContainer: {
		marginTop: 8 * theme.spacing.unit,

		[theme.breakpoints.up('lg')]: {
			marginTop: 2 * theme.spacing.unit
		},
		[theme.breakpoints.up('md')]: {
			marginTop: 6 * theme.spacing.unit
		},

		[theme.breakpoints.up('sm')]: {
			marginTop: 8 * theme.spacing.unit
		},
	},

	// Escape hatch for overly short desktop window
	"@media (max-height: 650px)": {
		contactContainer: {
			marginTop: 2 * theme.spacing.unit
		},
		screenLabel: {
			marginBottom: theme.spacing.unit,
		},
		gridContainer: {
			paddingTop: theme.spacing.unit,
			marginTop: -4 * theme.spacing.unit
		}
	},

	tipButton: {
		marginTop: 0.75 * theme.spacing.unit
	},
	tipPrimary: {
		color: CONSTANTS.COLORS.TIP
	},
	tipLink: {
		paddingBottom: 0.75 * theme.spacing.unit,
		paddingLeft: 0.75 * theme.spacing.unit
	},
	skia: {
		fontFamily: 'Montserrat, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;',
		fontSize: 3 * theme.spacing.unit,
		fontWeight: 900
	}
});

class CategorizeTips extends Component {

	onCloseTap = () => {
		const {messageSource} = this.props;
		// console.info(messageSource);
		if(messageSource) {
			messageSource.postMessage({
				type: "APP_CONTROL",
				action: "close"
			}, "*");

		// Not ideal, but adding in case anyone hits the site directly
		} else if(this.props.history.length > 0) {
			this.props.history.goBack();

		} else {
			window.history.back();
		}
	}

	// onContactTap = () => {
	// }

	render() {
		let {classes, isMobile, locationContact, recaptchaRef} = this.props;
		let {areaCode, prefix, lineNum} = locationContact ? {
			areaCode: locationContact.slice(1, 4), 
			prefix: locationContact.slice(4, 7), 
			lineNum: locationContact.slice(7, 11)
		} : {};

		return (
			<div>
				<HeaderBar 
					category="transparent"
					closeHandler={this.onCloseTap}
					recaptchaRef={recaptchaRef}
					recaptchaHandler={token => {}}
				/>
				<div className={classes.gridContainer}>
					<Grid container direction="column" alignItems="center" spacing={16}>
						<Grid item>
							<Typography variant="h5" className={classes.screenLabel}>Share Something ...</Typography>
						</Grid>
						<Grid item className={classes.btnLabel}>
							<Link className="primary" to="/share/positive/">
								<Button
									color="primary"
									aria-label="Good"
									ga-on="click"
									ga-event-category="WebApp"
									ga-event-action="Button Pressed"
									ga-event-label="Open Positive Form">
									<img src={positive} className={classes.imgBtn} alt="smile" />
								</Button>
							</Link>
							<Typography variant="h5" className={classes.skia}>Good</Typography>
						</Grid>
						<Grid item className={classes.btnLabel}>
							<Link className="primary" to="/share/uncertain/">
								<Button
									color="primary"
									aria-label="Sad"
									ga-on="click"
									ga-event-category="WebApp"
									ga-event-action="Button Pressed"
									ga-event-label="Open Neutral Form">
									<img src={uncertain} className={classes.imgBtn} alt="glum" />
								</Button>
							</Link>
							<Typography variant="h5" className={classes.skia}>Sad</Typography>
						</Grid>
						<Grid item className={classes.btnLabel}>
							<Link className="primary" to="/share/negative/">
								<Button
									color="primary"
									aria-label="Bad"
									ga-on="click"
									ga-event-category="WebApp"
									ga-event-action="Button Pressed"
									ga-event-label="Open Negative Form">
									<img src={negative} className={classes.imgBtn} alt="frown" />
								</Button>
							</Link>
							<Typography variant="h5" className={classes.skia}>Bad</Typography>
						</Grid>
						<Grid item className={classes.contactContainer}>
							{
								locationContact ? 
									isMobile ? 
										(<Button 
											aria-label="Talk with someone"
											ga-on="click"
											ga-event-category="WebApp"
											ga-event-action="Button Pressed"
											ga-event-label="Call Someone"
											href={`tel:${locationContact}`}
											>Talk with someone <MobilePhone className={classes.phone} />
										</Button>)
									: 
										(<Grid container direction="column" alignItems="center">
											<Grid item>
												<Typography variant="subtitle1">Talk with someone</Typography>
											</Grid>
											<Grid item>
												<Typography variant="subtitle1">1-{areaCode}-{prefix}-{lineNum}</Typography>
											</Grid>
										</Grid>)
								: null 
							}
						</Grid>
					</Grid>
				</div>
			</div>
		);
	}
}

CategorizeTips.propTypes = {
	classes: PropTypes.object.isRequired,
	messageSource: PropTypes.object,
	locationContact: PropTypes.string
};

export default withStyles(styles)(CategorizeTips);
